(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-present-item-lot', {
            parent: 'entity',
            url: '/purchase-present-item-lot?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.purchasePresentItemLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lots.html',
                    controller: 'PurchasePresentItemLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItemLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-present-item-lot-detail', {
            parent: 'entity',
            url: '/purchase-present-item-lot/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.purchasePresentItemLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-detail.html',
                    controller: 'PurchasePresentItemLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItemLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchasePresentItemLot', function($stateParams, PurchasePresentItemLot) {
                    return PurchasePresentItemLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-present-item-lot.new', {
            parent: 'purchase-present-item-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-dialog.html',
                    controller: 'PurchasePresentItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                quantity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('purchase-present-item-lot');
                });
            }]
        })
        .state('purchase-present-item-lot.edit', {
            parent: 'purchase-present-item-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-dialog.html',
                    controller: 'PurchasePresentItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchasePresentItemLot', function(PurchasePresentItemLot) {
                            return PurchasePresentItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-present-item-lot.delete', {
            parent: 'purchase-present-item-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-delete-dialog.html',
                    controller: 'PurchasePresentItemLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchasePresentItemLot', function(PurchasePresentItemLot) {
                            return PurchasePresentItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
